import { SHORT_DATE, SHORT_TIME } from '../constants/dates';
import dateFormatter from './dateFormatter';

export default function shortDateTime(date: any, timeZone: any) {
  return dateFormatter(date, `${SHORT_DATE} ${SHORT_TIME}`, timeZone);
}
